import { useCallback, useEffect, useRef } from 'react';
import { useBroadcastMessage } from '../../../hooks/useBroadcastMessage/useBroadcastMessage';
import { useOnBroadcastMessage } from '../../../hooks/useOnBroadcastMessage/useOnBroadcastMessage';
import { BaseSyncEvent } from '../../../models/baseSync.types';

export type IdleMonitorSyncEvent = BaseSyncEvent;

export type UseIdleMonitorSyncProps = {
  onStillWorkingFromAnotherTab: () => void;
  isIdle: boolean;
  setIdleTime: React.Dispatch<React.SetStateAction<number>>;
};

const IdleMonitorSyncId = 'ONE-IdleMonitorSync';

export const useIdleMonitorSync = ({ onStillWorkingFromAnotherTab, isIdle, setIdleTime }: UseIdleMonitorSyncProps) => {
  // We need to cast to any since we are using old TS version, without update or installing pollyfil it will cause errors
  // eslint-disable-next-line
  const tabId = useRef<string>((window as any).crypto.randomUUID());

  const prevIsIdle = useRef<boolean>(false);

  const { emitMessage } = useBroadcastMessage<IdleMonitorSyncEvent>({ channelName: IdleMonitorSyncId });
  const { emitMessage: emitActivityMessage } = useBroadcastMessage<IdleMonitorSyncEvent>({
    channelName: IdleMonitorSyncId,
    throttle: 1000,
  });

  const onAnotherTabStillWorkingCall = useCallback(
    (data: IdleMonitorSyncEvent) => {
      if (tabId.current !== data.tabId) {
        onStillWorkingFromAnotherTab();
      }
    },
    [onStillWorkingFromAnotherTab],
  );

  useOnBroadcastMessage<IdleMonitorSyncEvent>({
    channelName: IdleMonitorSyncId,
    callback: onAnotherTabStillWorkingCall,
  });

  useEffect(() => {
    if (prevIsIdle.current === true && isIdle === false) {
      setIdleTime(0);
      emitMessage({ tabId: tabId.current });
    }
    prevIsIdle.current = isIdle;
  }, [isIdle, emitMessage, setIdleTime]);

  return { emitActivityMessage, tabId };
};
